import { memo } from "react";

/** Component that only gets evaluated when the open state is modified */
export const memoWithOpen = (component) => {
  const areEqual = (prevProps, nextProps) => {
    return prevProps.open === nextProps.open;
  };

  return memo(component, areEqual);
};